import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class DIWGiftcard extends TKCustomElementFactory {
    select?: HTMLSelectElement;
    value?: string;
    priceContainer?: HTMLElement;

    constructor() {
        super();

        this.select = this.querySelector('#giftcard-value') || undefined;
        this.priceContainer = document.querySelector('[data-tk-price-container]') || undefined;
    }

    connectedCallback(): void {
        if (!this.select) throw new Error('DIWGiftcard: no select');

        const action = this.updatePrice.bind(this);
        this.pushListener({ event: 'change', element: this.select, action });

        this.updatePrice();
    }

    updatePrice(): void {
        if (!this.priceContainer) return;

        const value = this.select?.selectedOptions[0]?.textContent || undefined;
        this.priceContainer.innerHTML = value!;
    }
}
